define('common/constants',["require", "exports"], function (require, exports) {
    "use strict";
    var NetworkMemberTypes = (function () {
        function NetworkMemberTypes() {
        }
        NetworkMemberTypes.getSelectableNetworkMemberTypes = function () {
            var resultList = [NetworkMemberTypes.PortalAdmin, NetworkMemberTypes.PortalGateway, NetworkMemberTypes.PortalOperator, NetworkMemberTypes.PortalServiceOperator,
                NetworkMemberTypes.ClientAdmin, NetworkMemberTypes.ClientEmployee, NetworkMemberTypes.ClientClerk,
                NetworkMemberTypes.StbAdmin, NetworkMemberTypes.StbEmployee, NetworkMemberTypes.StbGateway, NetworkMemberTypes.StbServiceLogin];
            return resultList;
        };
        NetworkMemberTypes.getNetworkMemberTypesByOrganizationType = function (organizationtype) {
            var resultList = [];
            switch (organizationtype) {
                case OrganizationTypes.Addison:
                    resultList.push(NetworkMemberTypes.PortalAdmin);
                    //resultList.push(NetworkMemberTypes.PortalEmployee);
                    resultList.push(NetworkMemberTypes.PortalGateway);
                    resultList.push(NetworkMemberTypes.PortalOperator);
                    resultList.push(NetworkMemberTypes.PortalServiceOperator);
                    break;
                case OrganizationTypes.Stb:
                    resultList.push(NetworkMemberTypes.StbAdmin);
                    resultList.push(NetworkMemberTypes.StbEmployee);
                    resultList.push(NetworkMemberTypes.StbGateway);
                    resultList.push(NetworkMemberTypes.StbServiceLogin);
                    break;
                case OrganizationTypes.Client:
                    resultList.push(NetworkMemberTypes.ClientAdmin);
                    resultList.push(NetworkMemberTypes.ClientEmployee);
                    resultList.push(NetworkMemberTypes.ClientClerk);
                    break;
            }
            return resultList;
        };
        NetworkMemberTypes.getDisplayNameForGivenMemberType = function (memberType) {
            var result = "";
            switch (memberType) {
                case NetworkMemberTypes.PortalAdmin:
                    result = $.t("app:modules.common.constant_administrator", { ifMissing: "ADDISON Administrator" });
                    break;
                //case NetworkMemberTypes.PortalEmployee:
                //result = "Addison Mitarbeiter";
                //break;
                case NetworkMemberTypes.PortalGateway:
                    result = $.t("app:modules.common.constant_gateway", { ifMissing: "ADDISON Gateway" });
                    break;
                case NetworkMemberTypes.PortalOperator:
                    result = $.t("app:modules.common.constant_portalOperator", { ifMissing: "ADDISON Portalsachbearbeiter" });
                    break;
                case NetworkMemberTypes.PortalPostmaster:
                    result = $.t("app:modules.common.constant_postmaster", { ifMissing: "ADDISON" });
                    break;
                case NetworkMemberTypes.PortalServiceOperator:
                    result = $.t("app:modules.common.constant_portalSupport", { ifMissing: "ADDISON Portalsupport" });
                    break;
                case NetworkMemberTypes.StbEmployee:
                    result = $.t("app:modules.common.constant_employee", { ifMissing: "Kanzlei Arbeitnehmer" });
                    break;
                case NetworkMemberTypes.StbAdmin:
                    result = $.t("app:modules.common.constant_stbAdmin", { ifMissing: "Kanzlei Administrator" });
                    break;
                case NetworkMemberTypes.StbGateway:
                    result = $.t("app:modules.common.constant_stbGateway", { ifMissing: "Kanzlei Gateway" });
                    break;
                case NetworkMemberTypes.StbServiceLogin:
                    result = $.t("app:modules.common.constant_stbServiceLogin", { ifMissing: "Kanzlei Support" });
                    break;
                case NetworkMemberTypes.StbPostmaster:
                    result = $.t("app:modules.common.constant_stbPostmaster", { ifMissing: "Kanzlei" });
                    break;
                case NetworkMemberTypes.ClientAdmin:
                    result = $.t("app:modules.common.constant_clientAdmin", { ifMissing: "Mandant Administrator" });
                    break;
                case NetworkMemberTypes.ClientPostmaster:
                    result = $.t("app:modules.common.constant_clientPostmaster", { ifMissing: "Mandant" });
                    break;
                case NetworkMemberTypes.ClientEmployee:
                    result = $.t("app:modules.common.constant_clientEmployee", { ifMissing: "Mandant Arbeitnehmer" });
                    break;
                case NetworkMemberTypes.ClientClerk:
                    result = $.t("app:modules.common.constant_clientClerk", { ifMissing: "Mandant Portalbenutzer" });
                    break;
            }
            return result;
        };
        NetworkMemberTypes.PortalAdmin = "add_admin";
        NetworkMemberTypes.PortalEmployee = "add_employee";
        NetworkMemberTypes.PortalGateway = "add_gateway";
        NetworkMemberTypes.PortalPostmaster = "add_postmaster";
        NetworkMemberTypes.PortalOperator = "add_operator";
        NetworkMemberTypes.PortalServiceOperator = "add_service";
        NetworkMemberTypes.StbEmployee = "stb_employee";
        NetworkMemberTypes.StbAdmin = "stb_admin";
        NetworkMemberTypes.StbGateway = "stb_gateway";
        NetworkMemberTypes.StbServiceLogin = "stb_servicelogin";
        NetworkMemberTypes.StbPostmaster = "stb_postmaster";
        NetworkMemberTypes.ClientAdmin = "client_admin";
        NetworkMemberTypes.ClientPostmaster = "client_postmaster";
        NetworkMemberTypes.ClientEmployee = "client_employee";
        NetworkMemberTypes.ClientClerk = "client_clerk";
        return NetworkMemberTypes;
    }());
    exports.NetworkMemberTypes = NetworkMemberTypes;
    var OrganizationTypes = (function () {
        function OrganizationTypes() {
        }
        OrganizationTypes.getDisplayNameForGivenOrganizationType = function (organizationType) {
            var result = "";
            switch (organizationType) {
                case OrganizationTypes.Stb:
                    result = $.t("app:modules.common.constant_taxAdvisor", { ifMissing: "Steuerberater" });
                    break;
                case OrganizationTypes.Client:
                    result = $.t("app:modules.common.constant_client", { ifMissing: "Client" });
                    break;
            }
            return result;
        };
        OrganizationTypes.Addison = "ADDISON";
        OrganizationTypes.Client = "Client";
        OrganizationTypes.Stb = "Stb";
        return OrganizationTypes;
    }());
    exports.OrganizationTypes = OrganizationTypes;
    var OrganizationTypeCodes = (function () {
        function OrganizationTypeCodes() {
        }
        OrganizationTypeCodes.Addison = "add";
        OrganizationTypeCodes.Client = "client";
        OrganizationTypeCodes.Stb = "stb";
        return OrganizationTypeCodes;
    }());
    exports.OrganizationTypeCodes = OrganizationTypeCodes;
    var QueryString = (function () {
        function QueryString() {
        }
        QueryString.getValueByParameterName = function (name, url) {
            if (!url)
                url = window.location.href;
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
            if (!results)
                return null;
            if (!results[2])
                return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        };
        return QueryString;
    }());
    exports.QueryString = QueryString;
    exports.ALPHABET = "abcdefghijklmnopqrstuvwxyz";
    exports.CONTACT_GROUP_TOP_OFFSET = 30;
    exports.ENTER_KEY_CODE = 13;
    exports.BYTE_UNITS = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
    exports.MAIL_RECIPIENTS_CIRCLE_TEMPLATE_ID = "e9c896f1-1804-4cf8-af94-bf067b5a3cb4";
    exports.DEFAULT_AVATAR_PATH = "/html/content/images/avatar.png";
});

